import { useState } from "react";
// import MandaliDetail from "../../Pages/MandaliDetail"; // removed (page deleted)

import VillageWiseMandalDetailHeader from "../../Pages/Dashboard/VillageWiseMandaliDetailHeader";

const ShimmerCard = () => (
  <div className="govdash-villageCard-final">
    <div className="village-shimmer" style={{ height: "1rem", marginBottom: "0.6rem" }}></div>
    <div className="village-shimmer" style={{ height: "1.7rem" }}></div>
  </div>
);

const NoDataCard = () => (
  <div className="govdash-villageCard-final govdash-noVillageCard">
    <div className="govdash-noDataIcon">
      <i className="fas fa-village fa-2x"></i>
    </div>
    <div className="govdash-noDataTitle">No Mandali Found</div>
    <div className="govdash-noDataDesc">
      {document.querySelector(".govdash-searchInput")?.value ? "Try searching with different keywords" : "No villages available under this Yojana"}
    </div>
  </div>
);

export default function VillageWiseBhajanMandali({
  villageWiseBhajanMandaliData,
  fetchingVillageWiseBhajanMandaliData,
  selectedBhajanMandaliType,
  handleNavigateToMainTab,
  selectedVillage,
  selectedBhajanMandali,
  setSelectedBhajanmandali,
}) {
  const [search, setSearch] = useState("");
  const themes = ["glass-0", "glass-1", "glass-2", "glass-3", "glass-4"];

  const filteredData = villageWiseBhajanMandaliData?.filter((mandali) => mandali.BhajanMandaliName.toLowerCase().includes(search.toLowerCase()));

  //   const handleExport = () => {
  //     toast.dismiss();
  //     exportVillageWiseMandaliCount(selectedBhajanMandaliType, {
  //       onSuccess: (VillageMandaliData) => {
  //         if (!VillageMandaliData.length) {
  //           return notifyError("No Data Found");
  //         }
  //         const exportData = VillageMandaliData.map((item, index) => ({
  //           "Sr No ": index + 1,
  //           "Village Name": item?.VillageName || "",
  //           "Total Bhajan Mandali": item?.TotalBhajanMandali || "",
  //           "Total Members": item?.TotalBhajanMandaliMember || "",
  //         }));

  //         exportToExcel(exportData, "Bhajan_Mandali_Excel", {}, selectedBhajanMandaliType?.bhajanMandaliType);
  //       },
  //       onError: () => {
  //         return notifyError("Export failed. Please try again.");
  //       },
  //     });
  //   };

  const handleBhajanMandaliSelect = (mandali) => {
    setSelectedBhajanmandali(mandali);
  };

  return (
    <>
      <VillageWiseMandalDetailHeader
        selectedBhajanMandaliType={selectedBhajanMandaliType}
        handleNavigateToMainTab={handleNavigateToMainTab}
        totalMandaliInVillage={villageWiseBhajanMandaliData?.length || "0"}
        // villageCount={villageWiseMandaliCountData?.length}
        selectedVillage={selectedVillage}
        theme={selectedBhajanMandaliType?.theme}
      />
      <div className="d-flex justify-content-between">
        {/* <h3 className={"govdash-sectionTitle"}>Village Wise Mandali</h3> */}
        <h3 className={"govdash-sectionTitle"}>{selectedVillage["VillageName"]}</h3>
        <div className="d-flex gap-2">
          <div className="d-flex gap-3 align-items-center flex-wrap">
            <div className="govdash-searchWrapper">
              <i className="fas fa-search "></i>
              <input type="text" placeholder="Search Bhajan Mandali..." value={search} onChange={(e) => setSearch(e.target.value)} className="govdash-searchInput" />
              {search && (
                <button onClick={() => setSearch("")} className="govdash-clearSearch">
                  <i className="fas fa-times"></i>
                </button>
              )}
            </div>
          </div>
          {/* <div>
            <button onClick={handleExport} className="govdash-excelBtn mt-4" disabled={isExporting}>
              {isExporting ? (
                <>
                  <i className="fas fa-file-excel"></i>
                  <span className="govdash-btnLoader" />
                </>
              ) : (
                <>
                  <i className="fas fa-file-excel"></i>
                  <span className="ms-2">Export Excel</span>
                </>
              )}
            </button>
          </div> */}
        </div>
      </div>

      <div className="govdash-villageGrid-final">
        {fetchingVillageWiseBhajanMandaliData ? (
          Array(villageWiseBhajanMandaliData?.length)
            .fill()
            .map((_, i) => <ShimmerCard key={i} />)
        ) : filteredData.length > 0 ? (
          filteredData.map((mandali, idx) => {
            // villageWiseBhajanMandaliData.length > 0 ? (
            //   villageWiseBhajanMandaliData.map((mandali, idx) => {
            const theme = themes[idx % 5];

            return (
              <div key={mandali.BhajanMandaliName} className={`govdash-villageCard-final yojna-${theme}`} onClick={() => handleBhajanMandaliSelect(mandali)}>
                <div className="village-header-final">
                  <div className="village-name-final">{mandali.BhajanMandaliName}</div>
                </div>
                <div className="beneficial-row-final">
                  <span className="label">Member Count</span>
                  <span className="value">{mandali.MemberCount ?? "0"}</span>
                </div>
              </div>
            );
          })
        ) : (
          <NoDataCard />
        )}
      </div>
      {/* {selectedVillage && currBhajanMandaliState === "MandaliDetailData" && ( */}
      {/* MandaliDetail removed (page deleted) */}
    </>
  );
}
